export const BREVO_API_KEY = process.env.REACT_APP_BREVO_API_KEY;
export const BREVO_API_URL = process.env.REACT_APP_BREVO_API_URL;
export const BREVO_LIST_ID = process.env.REACT_APP_BREVO_LIST_ID;
export const LAUNCH_DATE = new Date(process.env.REACT_APP_BREVO_LAUNCH_DATE);
export const END_CAMPAIGN_DATE = new Date(
  process.env.REACT_APP_BREVO_END_CAMPAIGN_DATE
);
export const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL;
export const SENDER_EMAIL = process.env.REACT_APP_SENDER_EMAIL;
